// Requires: src/namespace.js
// Requires: src/myProduct.js
// Requires: src/register-product.purchaseDateErrorManager.js
// Requires: src/register-product.showStepOneButtons.js

window.BOL.RegisterProduct.PurchaseDate = (function($, myProduct, purchaseDateErrorManager, stepButtons) {

	'use strict';

	var CONST = {

		form:         		'data-product-dateField',
		field:        		'data-dateField-date',
		button:       		'data-dateField-button',
		errorBox:     		'data-dateField-form-error',
    error_Code:       'error-code',
		errorTitle:   		'data-dateField-form-error-title',
		errorText:    		'data-dateField-form-error-message',
		introText:    		'data-dateField-text',
		currentState: 		'data-dateField-state',
		promoFields:  		'data-promofields-code',
		dataDateSelected: 'data-date-selected',
		promoButton: 			'data-promofields-button',
		baseClass:    		'online--product-result-details__promo-state',
		loading:      		'--loading',
		success:      		'--success'
	};

	// Elements
	var $form         			= getEl(CONST.form).eq(0);
	var $field        			= getEl(CONST.field).eq(0);
	var $button       			= getEl(CONST.button).eq(0);
	var $errorBox     			= getEl(CONST.errorBox).eq(0);
  var $error_Code         = getEl(CONST.error_Code);
	var $errorTitle   			= getEl(CONST.errorTitle).eq(0);
	var $errorText    			= getEl(CONST.errorText).eq(0);
	var $introText    			= getEl(CONST.introText).eq(0);
	var $currentState 			= getEl(CONST.currentState).eq(0);
	var $promoFields  			= getEl(CONST.promoFields).eq(0);
	var $promoButton  			= getEl(CONST.promoButton).eq(0);
	var $dataDateSelected 	= getEl(CONST.dataDateSelected).eq(0);

	var productData;
	var REQUEST_URL;
	window.hidePromoBool = true;

	// DEV ENVIRONMENT
	// If Styleguide Environment
	if (window.envStyleguide) {
		REQUEST_URL = '/_sg-client/example_data/add-purchase-date.json';
	} else {
		REQUEST_URL = '/api/sitecore/PurchaseDate/Post';
	}

	// Get Element
	function getEl(elName) {
		return $('[' + elName + ']');
	}

	// Enable/Disble promo input
	function togglePromo() {
		$promoFields.removeAttr('disabled');  //Enable input
		$promoButton.removeAttr('disabled');  //Enable button
	}

	function resetShowState() {
		$currentState.attr('class', CONST.baseClass);
	}

	function setState(state) {
		resetShowState();
		$currentState.addClass(CONST.baseClass + state);
	}

	function setProductData(data) {
		productData = data;
	}

	function showDefaultPurchaseDateText(showText) {
		if(showText) {
			$introText.show();
		} else {
			$introText.hide();
		}
	}

	// reset the state when changed
	function resetState() {
		$error_Code.hide();
	    $errorBox.hide();
	    purchaseDateErrorManager.hideError();
	}

	// Addproduct (hook into the main js file to add product)
	function addProduct() {
		myProduct.add(productData);
	}

	// change success state
	function changeSucessState() {
		$field.attr('disabled', 'disabled');
		$button.attr('disabled', 'disabled');
		$errorBox.hide();
		$error_Code.hide();
		purchaseDateErrorManager.hideError();

		setState(CONST.success);
		stepButtons.toggleButtons(true);
	}

	// change fail state

	function changeFailState(error) {
	    purchaseDateErrorManager.showError(error);
	    resetShowState();

	}

	//sucess
	function handleSuccess(response) {
		var inDate = response.success;

		if(inDate) {
			changeSucessState();
			addProduct();
			togglePromo();
			$dataDateSelected.hide(300);
			return;
		}

		changeFailState(response.error);
		return;
	}

	// fail
	function handleFail() {
		changeFailState();
	}

	// post to server
	function postToServer(date) {

		// IF DEV ENVIRONMENT
		if (window.envStyleguide) {
			// Should be post when it is integrated.
	    $.get(REQUEST_URL, { date: date,product:productData })
			.done(handleSuccess)
			.fail(handleFail);
		// IF LIVE ENVIRONMENT
		} else {
			// Should be post when it is integrated.
	    $.post(REQUEST_URL, { date: date,product:productData })
			.done(handleSuccess)
			.fail(handleFail);
		}

	}

	// submit handler
	function handleSubmitEvent(event) {
	  var inputValue = $field.val();

	  if (event.isDefaultPrevented()) {
	    return;
	   } else {
	     event.preventDefault();
			 event.stopImmediatePropagation();

	     setState(CONST.loading);
	     resetState();
	     postToServer(inputValue);
	   }
	}

	function setFormVisibility(isVisible) {
		if(isVisible) {
		    purchaseDateErrorManager.hideError();
		    $errorBox.hide();
			$error_Code.hide();
			resetShowState();
			$field.removeAttr('disabled');
			$button.removeAttr('disabled');
			$form.show();
		} else {
			$form.hide();
		}
	}

	function init() {

		// submit event
		$form.validator({
			disable: false,
			focus: false
		}).on('submit', handleSubmitEvent);
		purchaseDateErrorManager.init();
	}

	init();

	return {
		togglePromo: 					 			 togglePromo,
		setProductData:              setProductData,
		setFormVisibility:           setFormVisibility,
		showDefaultPurchaseDateText: showDefaultPurchaseDateText
	};

})($jq, window.BOL.myProduct, window.BOL.RegisterProduct.purchaseDateErrorManager, window.BOL.RegisterProduct.showStepOneButtons);
